<script setup>
import {ref} from 'vue'
import {cn} from '@/lib/utils'

import {Button} from "@/components/ui/button";
import {Loader} from 'lucide-vue-next';
import {Input} from "@/components/ui/input";
import {Label} from "@/components/ui/label";
import {Alert, AlertDescription} from "@/components/ui/alert";
import {AlertCircle} from 'lucide-vue-next';
import ErrorAlert from "@/components/ui/error-alert.vue";

import {Login} from "../services/userService";

const isLoading = ref(false)
const error = ref('')
let email = ref('')
let password = ref('')

async function onSubmit(event) {
  event.preventDefault()
  isLoading.value = true
  error.value = ''

  try {
    await Login(email.value, password.value)
    window.location.href = '/';
  } catch (err) {
    error.value = 'Invalid email or password'
    console.error(err)
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div class="container relative hidden h-[800px] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
    <div class="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
      <div class="absolute inset-0 bg-pink-600"/>
      <div class="relative z-20 flex items-center justify-center text-lg font-medium h-screen">
        <img src="@/assets/logo.svg" alt="PanelPop" class="h-1/2 w-auto">
      </div>
    </div>
    <div class="lg:p-8">
      <div class="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
        <div class="flex flex-col space-y-2 text-center">
          <h1 class="text-2xl font-semibold tracking-tight">
            Welcome back
          </h1>
          <p class="text-sm text-muted-foreground">
            Enter your email and password below to continue
          </p>
        </div>
        <div :class="cn('grid gap-6', $attrs.class ?? '')">
          <form @submit="onSubmit">
            <div class="grid gap-2">
              <ErrorAlert v-if="error" :error="{ message: error }" />
              <div class="grid gap-1">
                <Label class="sr-only" for="email">
                  Email
                </Label>
                <Input
                    id="email"
                    placeholder="name@example.com"
                    type="email"
                    auto-capitalize="none"
                    auto-complete="email"
                    auto-correct="off"
                    :disabled="isLoading"
                    v-model="email"
                />
              </div>
              <div class="grid gap-1">
                <Label class="sr-only" for="password">
                  Password
                </Label>
                <Input
                    id="password"
                    placeholder="Password"
                    type="password"
                    auto-complete="current-password"
                    :disabled="isLoading"
                    v-model="password"
                />
              </div>
              <Button :disabled="isLoading">
                <Loader v-if="isLoading" class="mr-2 h-4 w-4 animate-spin"/>
                Sign In with Email
              </Button>
            </div>
          </form>
        </div>
        <p class="px-8 text-center text-sm text-muted-foreground">
          By clicking continue, you agree to our
          <a
              href="/terms"
              class="underline underline-offset-4 hover:text-primary"
          >
            Terms of Service
          </a>
          and
          <a
              href="/privacy"
              class="underline underline-offset-4 hover:text-primary"
          >
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>